<div class="pedido-nao-liberado-card-info-limite-credito-excedido card card-warning">
    <div class="card-header">
        <p class="card-title mb-0">
            Limite de Crédito Excedido
        </p>
    </div>
    <ul class="list-group list-group-flush list-group-vertical">
        <li class="list-group-item">
            <span class="list-group-item-title">
                Motivo da Não Liberação
            </span>
            <span class="list-group-item-value">
                Este {{settings?.tipoVenda | pedidoTipoVendaSinonimo}} não foi liberado por que o valor total ultrapassou o limite de crédito disponível do cliente
            </span>            
        </li>
        <li class="list-group-item">
            <span class="list-group-item-title">
                Não Liberado em
            </span>
            <span class="list-group-item-value">
                {{settings?.dataNaoLiberado | date: 'dd/MM/yyyy'}} às {{settings?.dataNaoLiberado | date: 'HH:mm'}}
            </span>            
        </li>
        <li class="list-group-item">
            <span class="list-group-item-title">
                Limite de Crédito Disponível
                <i
                    class="fa fa-info-circle text-muted ml-1"
                    sgtTooltip="Limite de crédito que o cliente ainda possuía disponível no momento da não liberação deste {{settings?.tipoVenda | pedidoTipoVendaSinonimo}}."
                    tooltipPosition="top"
                    sgtTooltipClass="sgt-tooltip--multiline"
                ></i>
            </span>
            <span class="list-group-item-value">
                {{settings?.limiteCreditoDisponivelNaoLiberado | currencyFormat: 1:2:2}}
            </span>
        </li>       
        <li class="list-group-item">
            <span class="list-group-item-title">
                Valor em Aberto
                <i
                    class="fa fa-info-circle text-muted ml-1"
                    sgtTooltip="Valor total dos orçamentos/pedidos em aberto que ainda não deduziram o limite disponível, ou seja, orçamentos/pedidos que ainda não foram exportados para o ERP."
                    tooltipPosition="top"
                    sgtTooltipClass="sgt-tooltip--multiline"
                ></i>
            </span>
            <span class="list-group-item-value">
                {{settings?.valorEmAbertoNaoLiberado | currencyFormat: 1:2:2}}
            </span>
        </li>         
        <li class="list-group-item">
            <span class="list-group-item-title">
                Valor Total
                <i
                    class="fa fa-info-circle text-muted ml-1"
                    sgtTooltip="Valor total deste {{settings?.tipoVenda | pedidoTipoVendaSinonimo}}."
                    tooltipPosition="top"
                    sgtTooltipClass="sgt-tooltip--multiline"
                ></i>                
            </span>
            <span class="list-group-item-value">
                {{settings?.valorTotal | currencyFormat: 1:2:2}}
            </span>            
        </li>                        
        <li class="list-group-item">
            <span class="list-group-item-title">
                Saldo do Limite de Crédito
                <i
                    class="fa fa-info-circle text-muted ml-1"
                    sgtTooltip="Saldo resultante: limite de crédito disponível menos o valor dos orçamentos/pedidos em aberto menos o valor total deste {{settings?.tipoVenda | pedidoTipoVendaSinonimo}}."
                    tooltipPosition="top"
                    sgtTooltipClass="sgt-tooltip--multiline"
                ></i>
            </span>
            <span class="list-group-item-value">
                {{settings?.saldoLimiteCreditoNaoLiberado | currencyFormat: 1:2:2}}
            </span>
        </li>
    </ul>

    <div class="card-body">
        <p class="card-title mb-2" style="font-size: 12px; font-weight: 600;">Orçamentos/Pedidos em Aberto</p>
        <sgt-table [settings]="tableSettings">
            <tr header>
                <th class="text-right">Número</th>
                <th class="text-right">Número ERP</th>
                <th class="text-center">Emissão</th>
                <th class="text-center">Status</th>
                <th class="text-right">Valor Total R$</th>
            </tr>

            <ng-container body>
                <tr *ngFor="let pedido of settings?.pedidosEmAbertoNaoLiberado; trackBy: trackByPedidoId">
                    <td class="text-right">{{ pedido.numero || '-' }}</td>
                    <td class="text-right">{{ pedido.numeroErp || '-' }}</td>
                    <td class="text-center">{{ (pedido.dataEmissao | date: 'dd/MM/yyyy') || '-' }}</td>
                    <td class="text-center">{{ (pedido.status | pedidoStatus) || '-' }}</td>
                    <td class="text-right">{{ pedido.valorTotal | currencyFormat: 1:2:2 }}</td>
                </tr>
            </ng-container>

            <ng-container empty>
                <tr>
                    <td colspan="5" class="text-center text-muted py-4">Nenhum orçamento/pedido em aberto</td>
                </tr>
            </ng-container>
        </sgt-table>
    </div>
</div>